export default {"src":"/_next/static/media/credit-cards-icon.5a163ed8.svg","height":30,"width":30};